import EventDispatcher from '../events/EventDispatcher';

class StreamTexture extends EventDispatcher {
  constructor(streamName) {
    super();

    this.setStreamName(streamName);
  }

  setStreamName(name) {
    this.streamName = name || 'Stream';
  }

  setStreamSize(w, h) {
    this.streamWidth = w;
    this.streamHeight = h;
    this.setTexturePosition(this._tx, this._ty, this._tw, this._th);
  }

  getTextureX() {
    return this._tx;
  }

  getTextureY() {
    return this._ty;
  }

  getTextureWidth() {
    return this._tw;
  }

  getTextureHeight() {
    return this._th;
  }

  setTexturePosition(tx, ty, tw, th) {
    if (typeof tx === 'object') {
      const obj = tx;
      tx = obj.x;
      ty = obj.y;
      tw = obj.w;
      th = obj.h;
    }

    this._tx = tx;
    this._ty = ty;
    this._tw = tw;
    this._th = th;

    this.tw = tw / this.streamWidth;
    this.th = th / this.streamHeight;
    this.tx = tx / this.streamWidth;
    this.ty = 1 - (ty / this.streamHeight) - this.th;

    this.emit('change');
  }

  setPosition(x, y, w, h) {
    const iw = window.innerWidth;
    const ih = window.innerHeight;
    this.w = w / iw;
    this.h = h / ih;
    this.x = x / iw;
    this.y = 1 - (y / ih) - this.h;

    this.emit('change');
  }

  toString() {
    return [this.x, this.y, this.w, this.h, this.tx, this.ty, this.tw, this.th].join(',');
  }
}

export default StreamTexture;



// WEBPACK FOOTER //
// ./public/js/chyronhego/plugin/StreamTexture.js